import Button from "@pathwright/ui/src/components/button/Button"
import SubmitButton from "@pathwright/ui/src/components/button/SubmitButton"
import TextArea from "@pathwright/ui/src/components/form/form-textarea/TextArea"
import Text from "@pathwright/ui/src/components/ui/Text"
import compose from "lodash/flowRight"
import PropTypes from "prop-types"
import { Field, Form, Submit } from "react-connect-form-forked"
import styled from "styled-components"
import withCreatePathItem from "../graphql/withCreatePathItem"
import withUpdatePathItem from "../graphql/withUpdatePathItem"
import * as PathUI from "../ui/PathUI"
import { useEditPathContext } from "./EditPath"

const StyledTextArea = styled(TextArea)`
  &,
  textarea {
    padding: 0 !important;
    min-height: inherit !important;
    font-size: inherit !important;
    line-height: inherit !important;
    font-weight: inherit !important;
    color: inherit !important;
    text-align: center;
    ::placeholder {
      color: inherit !important;
    }
    :placeholder-shown {
      opacity: 0.7;
    }
  }
`
const Footer = styled.footer`
  display: flex;
  align-items: baseline;
  justify-content: flex-end;
`

const EditPathLessonForm = ({
  pathId,
  pathItem,
  updatePathItem,
  createPathItem,
  index,
  onClose
}) => {
  const { clearEditingState, handleChange } = useEditPathContext()

  const handleSubmit = async ({ name, description }) => {
    if (pathItem) {
      await updatePathItem({ ...pathItem, name, description })
    } else {
      await createPathItem({
        name,
        description,
        type: "lesson",
        order: index,
        pathId: pathId
      })
      clearEditingState()
      // alert parent (legacy/client) that changes have occurred.
      handleChange()
    }
    onClose()
  }

  return (
    <PathUI.PathLessonContainer>
      <Form initialValue={pathItem} onSubmit={handleSubmit}>
        <PathUI.PathLessonHeader>
          <Text.H4 inverted>
            <Field
              name="name"
              component={StyledTextArea}
              placeholder="Group Name"
              type="text"
              hideStatus
              required
              inverted
              minimal
            />
          </Text.H4>
          <Text.Meta inverted>
            <Field
              name="description"
              component={StyledTextArea}
              placeholder="Enter a description (optional)"
              type="text"
              hideStatus
              autoSize
              inverted
              minimal
            />
          </Text.Meta>
        </PathUI.PathLessonHeader>
        <Footer>
          <Button onClick={onClose} styleType="blank" inverted>
            Cancel
          </Button>
          <Submit component={SubmitButton} styleType="primary" inverted>
            {pathItem ? "Save" : "Create"}
          </Submit>
        </Footer>
      </Form>
    </PathUI.PathLessonContainer>
  )
}

EditPathLessonForm.displayName = "EditPathLessonForm"

EditPathLessonForm.propTypes = {
  index: PropTypes.number,
  pathId: PropTypes.number,
  onClose: PropTypes.func.isRequired
}

export default compose(
  withCreatePathItem,
  withUpdatePathItem
)(EditPathLessonForm)
